import { Car, Train, MapPin, Clock, Phone, Navigation } from 'lucide-react';
import type { City } from '@/data/cities';

interface Props { city: City }

const VilleAcces = ({ city }: Props) => (
  <section className="py-16 md:py-20 px-6 lg:px-8 bg-background">
    <div className="max-w-5xl mx-auto">
      <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2 text-center">Accès</p>
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-6 text-center">
        Cygnature Production, votre agence proche de {city.name}
      </h2>
      <p className="text-muted-foreground text-sm text-center max-w-2xl mx-auto leading-relaxed mb-10">
        À seulement {city.distanceKm} km et {city.driveTime} en voiture depuis {city.name}, notre agence basée à Troyes est idéalement située pour intervenir sur tous vos événements.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        <div className="p-6 rounded-2xl border border-border bg-card hover:border-primary/20 transition-colors">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center mb-4">
            <Car size={20} className="text-primary" strokeWidth={1.5} />
          </div>
          <h3 className="font-heading font-bold text-foreground mb-2">En voiture</h3>
          <p className="text-sm text-muted-foreground mb-3">{city.driveTime} depuis {city.name}, accès rapide et direct.</p>
          <div className="flex items-center gap-2 text-xs">
            <Navigation size={11} className="text-primary" />
            <span className="font-heading font-semibold text-primary">{city.distanceKm} km — {city.driveTime}</span>
          </div>
        </div>
        <div className="p-6 rounded-2xl border border-border bg-card hover:border-primary/20 transition-colors">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center mb-4">
            <Train size={20} className="text-primary" strokeWidth={1.5} />
          </div>
          <h3 className="font-heading font-bold text-foreground mb-2">En train</h3>
          <p className="text-sm text-muted-foreground mb-3">Gare de Troyes desservie par le TER et les lignes régionales.</p>
          <div className="flex items-center gap-2 text-xs">
            <Clock size={11} className="text-primary" />
            <span className="font-heading font-semibold text-primary">Lignes TER & régionales</span>
          </div>
        </div>
        <div className="p-6 rounded-2xl border border-border bg-card hover:border-primary/20 transition-colors">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center mb-4">
            <MapPin size={20} className="text-primary" strokeWidth={1.5} />
          </div>
          <h3 className="font-heading font-bold text-foreground mb-2">Sur place</h3>
          <p className="text-sm text-muted-foreground mb-3">Parking gratuit. Nous nous déplaçons aussi chez vous pour les repérages.</p>
          <div className="flex items-center gap-2 text-xs">
            <Phone size={11} className="text-primary" />
            <span className="font-heading font-semibold text-primary">06 71 35 15 50</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default VilleAcces;
